import Conditions from '../conditions';

export default {
    state: {
        source: null,
        __conditions: [],
        pagination: {},
        filtersShown: null,
        state: 'loading',
        dataType: 'project',
        isExclusions: false,
    },
    mutations: {
        setViewerSource: (state, source) => state.source = source,
        setFiltersShown: (state, filtersShown) => state.filtersShown = filtersShown,
        setViewerConditions: (state, conditions) => state.__conditions = conditions,
        setState: (state, s) => state.state = s,
        addCondition: (state, condition) => {
            if (state.__conditions.some((c) => c.key === condition.key && c.value === condition.value)) return;
            state.__conditions.push(condition);
        },
        removeByKey: (state, key) =>
            Conditions.prototype.removeByKey.call(state.__conditions, key),
        removeByCondition: (state, condition) =>
            Conditions.prototype.removeByCondition.call(
                state.__conditions,
                condition
            ),
        removeConditionByValue: (state, condition) =>
            Conditions.prototype.removeConditionByValue.call(
                state.__conditions,
                condition
            ),
        setDataType: (state, type) => state.dataType = type
    },
    actions: {
        changeSource: (context, source) => context.commit('setViewerSource', source),
        addViewerCondition: (context, condition) => {
            if (condition.static) context.commit('removeByKey', condition.key);
            if (condition.clearKeys) {
                for (let key of condition.clearKeys) context.commit('removeByKey', key);
            }
            context.commit('addCondition', condition);
        },
        constructConditionsFromQuery: (context, query) => {
            let converter = (object) => {
                return {
                    key: object.key,
                    value: object.value
                };
            };

            let a = Immutable.fromJS(Conditions.prototype.constructFromObject(query).map(converter));
            let b = Immutable.fromJS(context.state.__conditions.map(converter));

            if (a.isSubset(b)) return; // If both queries are the same, no reason to set viewer conditions

            context.commit(
                'setViewerConditions',
                Conditions.prototype.constructFromObject(query)
            );
        },
    },
    getters: {
        conditions: (state) => {
            var override, strValue;

            if (state.dataType === "project" && state.project){
                strValue = state.project.slug;
            }

            return state.__conditions.filter((c) => c.key !== "project" && c.key !== "group")
                .concat(state[state.dataType] ? [{
                    key: state.dataType,
                    keyOverride: override || undefined,
                    value: strValue || undefined,
                    hidden: true,
                    static: true
                }] : []);
        }
    }
};
